export enum CookieKeys {
    tcjwt = 'tcjwt',
}
